"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    root: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        width: 1,
        margin: -1,
        padding: 0,
        overflow: 'hidden',
        position: 'absolute'
    }
};
//# sourceMappingURL=invisible.style.js.map